// import { routerMiddleware } from 'connected-react-router'
import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware, { Saga } from 'redux-saga'
import * as Sentry from '@sentry/react'

const sentryReduxEnhancer = Sentry.createReduxEnhancer()

let store

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
  }
}

// chrome extension helper or use just the regular compose if not installed
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const configureStore = function (rootReducer: () => any, rootSaga: () => any) {
  // init saga
  const sagaMiddleware = createSagaMiddleware({
    onError(err) {
      Sentry.captureException(err)
    },
  })

  // init store
  if (process.env.MODE === 'dev') {
    store = createStore(
      rootReducer(),
      // rootReducer(history),
      composeEnhancers(
        applyMiddleware(sagaMiddleware),
        // applyMiddleware(routerMiddleware(history), sagaMiddleware),
      ),
    )
  } else {
    store = createStore(
      rootReducer(),
      // rootReducer(history),
      composeEnhancers(
        applyMiddleware(sagaMiddleware),
        sentryReduxEnhancer,
        // applyMiddleware(routerMiddleware(history), sagaMiddleware),
      ),
    )
  }

  // run watchers
  sagaMiddleware.run(rootSaga as Saga<any[]>)

  return store
}

export default configureStore

// export type AppDispatch = typeof store.dispatch;
// export type RootState = ReturnType<typeof store.getState>;
